(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sbd-customer-grid"] && !Shopify.designMode) return;
  try {
    /* A deliberate play action loads only the chosen clip and keeps native controls available. */
document.querySelectorAll('[data-customer-video]').forEach((tile) => {
 const video = tile.querySelector('video');
 const button = tile.querySelector('button');
 const feedback = tile.querySelector('[role="status"]');
 if (!video || !button) return;
 video.addEventListener('play', () => {
  /* Keep customer voices from overlapping and avoid decoding several clips at once. */
  document.querySelectorAll('[data-customer-video] video').forEach((other) => {
   if (other !== video && !other.paused) other.pause();
  });
  button.hidden = true;
  feedback.hidden = true;
 });
 video.addEventListener('ended', () => { button.hidden = false; });
 button.addEventListener('click', async () => {
  button.disabled = true;
  feedback.hidden = true;
  try {
   /* Explicitly load before playing so lazy video handling cannot swallow the first interaction. */
   video.removeAttribute('loading');
   if (video.readyState === 0) video.load();
   await video.play();
   button.hidden = true;
  } catch {
   feedback.hidden = false;
   console.warn('[SB Diamonds] Customer video playback could not start.');
  } finally { button.disabled = false; }
 });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sbd-origin-shelf"] && !Shopify.designMode) return;
  try {
    /* Give every category independent WAI-ARIA tabs, including arrows, Home and End. */
document.querySelectorAll('[data-origin-shelf]').forEach((shelf) => {
 const tablist = shelf.querySelector('[role="tablist"]');
 const tabs = [...shelf.querySelectorAll('[role="tab"]')];
 const panels = [...shelf.querySelectorAll('[role="tabpanel"]')];
 if (!tablist || tabs.length !== 2 || panels.length !== 2) return;
 const activate = (tab, focus = false) => {
  tabs.forEach((item) => {
   const selected = item === tab;
   item.setAttribute('aria-selected', String(selected));
   item.tabIndex = selected ? 0 : -1;
  });
  panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
  if (focus) tab.focus();
 };
 tablist.hidden = false;
 tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => activate(tab));
  tab.addEventListener('keydown', (event) => {
   let next;
   if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
   else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
   else if (event.key === 'Home') next = 0;
   else if (event.key === 'End') next = tabs.length - 1;
   else return;
   event.preventDefault();
   activate(tabs[next], true);
  });
 });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sbd-showroom-map"] && !Shopify.designMode) return;
  try {
    /* Mount only at desktop widths; the direct Google Maps link remains a no-JS fallback. */
document.querySelectorAll('[data-showroom-map]').forEach((map) => {
 const desktop = window.matchMedia('(min-width:801px)');
 const mount = map.querySelector('[data-map-mount]');
 const template = map.querySelector('template');
 const update = () => {
  if (desktop.matches && !mount.firstElementChild) mount.append(template.content.cloneNode(true));
  else if (!desktop.matches) mount.replaceChildren();
 };
 desktop.addEventListener('change', update);
 update();
});
  } catch(e) { console.error(e); }
})();

})();
